import { Timestamp } from "../../statistics/timeseries-statistics/model/Timestamp.model";

export interface ItsmMaintenanceWorkViewModel {
  itsmId: string;
  status: string;
  startTime: Timestamp;
  endTime: Timestamp;
  sozOrderNumbers: number[];
  serviceNames: string[];
}
export interface ItsmMaintenanceWorkApiModel {
  itsmId: string;
  status: string;
  startTime: Timestamp;
  endTime: Timestamp;
  networkServices: MaintanedNetworkService[];
}

interface MaintanedNetworkService {
  sozOrderNumber: number;
  serviceName: string;
}

export const mapItsmMaintenanceWorkApiModelToViewModel = (maintenanceWork: ItsmMaintenanceWorkApiModel): ItsmMaintenanceWorkViewModel => {
  const { sozOrderNumbers, serviceNames } = maintenanceWork.networkServices
    .map(networkService => ({
      sozOrderNumbers: [networkService.sozOrderNumber],
      serviceNames: [networkService.serviceName]
    }))
    .reduce(
      (previous, current) => ({
        sozOrderNumbers: [...previous.sozOrderNumbers, ...current.sozOrderNumbers],
        serviceNames: [...previous.serviceNames, ...current.serviceNames] }),
      {
        sozOrderNumbers: [],
        serviceNames: []
      });
  return {
    ...maintenanceWork,
    sozOrderNumbers,
    serviceNames
  };
};